module.exports = __webpack_public_path__ + "assets/img/9f07f5351068362bfe0961e1963981a9.svg";